import React from 'react'

import { useTranslation } from 'react-i18next'

import { Link } from '../components/Link'
import { ColorTypeText } from '../components/types'

interface ImprintProps {
    textColor: ColorTypeText
}

export const Imprint: React.FC<ImprintProps> = ({ textColor }) => {
    const { t } = useTranslation()

    return (
        <div className="w-full flex flex-col mx-auto my-10 justify-center items-center">
            <div
                className={`max-w-container-s min-h-[1200px] h-auto flex flex-col justify-between mx-5 ${textColor} xs:min-h-[2000px]`}>
                <div className="text-4xl font-bold">{t('imprint.title')}</div>
                <div>
                    {t('imprint.name')} <br></br>
                    {t('imprint.address.street')} <br></br>
                    {t('imprint.address.city')}
                </div>
                <div>
                    {t('imprint.contact.phone')} <br></br>
                    {t('imprint.contact.fax')} <br></br>
                    <Link className="underline" href={`mailto:${t('imprint.contact.email')}`}>
                        {t('imprint.contact.email')}
                    </Link>{' '}
                </div>
                <div>{t('imprint.legalInfo.tmg')}</div>
                <div>{t('imprint.legalInfo.qualification')}</div>
                <div>{t('imprint.legalInfo.regulations')}</div>
                <Link href="www.laek-rlp.de/recht/berufsordnung/berufsordnung.php" className="underline">
                    {t('imprint.legalInfo.regulationsLink')}
                </Link>
                <div>{t('imprint.legalInfo.viewRegulations')}</div>
                <div>{t('imprint.legalInfo.supervisoryAuthority')}</div>
                <Link className="underline" href="http://www.kv-rlp.de">
                    {t('imprint.legalInfo.authorityLink')}
                </Link>
                <div>
                    <p className="font-bold">{t('imprint.legalNotice.title')} </p>
                    {t('imprint.legalNotice.content')}
                </div>
                <div>{t('imprint.disclaimer')}</div>
                <div>{t('imprint.liability')}</div>
                <div className="flex flex-col justify-between">
                    <p className="font-bold">{t('imprint.professionalInfo.title')}</p>
                    {t('imprint.professionalInfo.content')} <br></br>
                    <Link className="underline" href="">
                        {t('imprint.professionalInfo.website')}
                    </Link>{' '}
                    <br />
                    {t('imprint.professionalInfo.society')} <br />
                    <Link className="underline" href={t('imprint.professionalInfo.society_url')}>
                        {t('imprint.professionalInfo.society_url')}
                    </Link>{' '}
                    <br />
                    {t('imprint.professionalInfo.association')} <br />
                    <Link className="underline" href={t('imprint.professionalInfo.association_url')}>
                        {t('imprint.professionalInfo.association_url')}
                    </Link>{' '}
                    <br />
                </div>
            </div>
        </div>
    )
}
